import { useOption } from '@react-aria/listbox';
import PropTypes from 'prop-types';
import React__default from 'react';
import { useTrackDisabledState } from '../../contexts/internal/collection/collection.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    /**
   * Whether or not the option is disabled.
   */ disabled: PropTypes.bool,
    /**
   * Whether or not the option has a thumbnail.
   */ withThumbnail: PropTypes.bool,
    /**
   * The contents to render inside the ListboxButton. Can include JSX
   */ label: PropTypes.node,
    /**
   * The option's human-readable string. Required if using JSX inside of an option
   */ textValue: PropTypes.string
};
const propKeysToRemove = [
    ...Object.keys(propTypes),
    'textValue'
];
/**
 * ListboxOptionInternal is the internal component for rendering an item
 *
 * The public ListboxOption is only used for the ListboxList to parse the children and store in state
 *
 * @subcomponent Listbox
 */ const ListboxOptionInternal = ({ item, state })=>{
    const ref = React__default.useRef(null);
    var _item_props;
    // get props from ListboxOption
    // if disabled is not given here, it can also be supplied as part of `disabledKeys` on the root component
    const { disabled } = (_item_props = item.props) !== null && _item_props !== void 0 ? _item_props : {};
    const { optionProps, isFocused, isFocusVisible } = useOption(item, state, ref);
    useTrackDisabledState(item.key, disabled);
    const browserFocusVisible = React__default.useMemo(()=>{
        var _window_CSS_supports, _window_CSS, _window;
        return (_window = window) === null || _window === void 0 ? void 0 : (_window_CSS = _window.CSS) === null || _window_CSS === void 0 ? void 0 : (_window_CSS_supports = _window_CSS.supports) === null || _window_CSS_supports === void 0 ? void 0 : _window_CSS_supports.call(_window_CSS, 'selector(:focus-visible)' );
    }, []);
    const focused = browserFocusVisible ? isFocusVisible : isFocused;
    const classes = new Set([
        'swan-listbox-option'
    ]);
    if (item.props.withThumbnail) classes.add('swan-listbox-option-with-thumbnail');
    if (focused) {
        classes.add('swan-listbox-option-focused');
    }
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "li",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        props: _object_spread({}, item.props, optionProps),
        classNames: classes
    }, item.rendered);
};

export { ListboxOptionInternal, propTypes };
